import type { PostHogConfig } from "posthog-js";
import { createContext, useContext, type ReactNode } from "react";
import { useUnsafeEffect } from "@wags/tanstack-start/react";
import {
    bootDeferredPostHog,
    deferredPostHog,
} from "./deferred-posthog-client.ts";

const PostHogClientContext = createContext(deferredPostHog);

export function PostHogProvider({
    apiKey,
    children,
    options,
}: {
    apiKey?: string;
    children: ReactNode;
    options?: Partial<PostHogConfig>;
}) {
    useUnsafeEffect(() => {
        bootDeferredPostHog(apiKey ?? "", options);
    }, [apiKey, options]);

    return (
        <PostHogClientContext.Provider value={deferredPostHog}>
            {children}
        </PostHogClientContext.Provider>
    );
}

export function usePostHog() {
    return useContext(PostHogClientContext);
}
